import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {
  Form, Button, Modal, Header, Icon, Dropdown,
} from 'semantic-ui-react';
import { get, isEmpty } from 'lodash';
import Validator from 'validatorjs';
import client from '../../apollo';
import customerDealerGroupQuery from '../../graphql/customerDealerGroupQuery';
import { DealerInfoAction } from './ListRow';

class AssignForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      groups: [],
      initialGroups: [],
      selectedGroupId: null,
      dealerGroup: null,
      debounceTimeout: null,
      searchQuery: '',
      groupNameError: null,
    };
  }

  handleSearchChange = (e, { searchQuery }) => {
    const { debounceTimeout: currentTimeout } = this.state;
    this.setState({ groups: [] });

    if (currentTimeout) {
      clearTimeout(currentTimeout);
    }

    const debounceTimeout = setTimeout(() => {
      const { searchQuery: query } = this.state;
      this.groupNameSearchQuery(query);
    }, 1000);

    this.setState({
      searchQuery,
      isLoading: true,
      debounceTimeout,
    });
  };

  componentDidMount() {
    this.groupNameSearchQuery();
  }

  groupNameSearchQuery = keyword => {
    client
      .query({
        query: customerDealerGroupQuery,
        variables: {
          groupName: keyword,
          page: 1,
          size: 200,
        },
      })
      .then(({ data }) => {
        const groupData = get(data, 'customerDealerGroupList');
        if (groupData && groupData.length) {
          const groups = groupData.map(group => ({
            key: group.groupId,
            value: group.groupId,
            text: group.groupName,
          }));
          this.setState({
            groups,
            isLoading: false,
          });
          const { initialGroups } = this.state;
          if (!keyword && !initialGroups.length) {
            this.setState({ initialGroups: groups });
          }
        } else {
          this.setState({
            isLoading: false,
          });
        }
      })
      .catch(() => {
        this.setState({ isLoading: false });
      });
  };

  onHandleSelect = () => (event, { value }) => {
    const { groups } = this.state;
    const dealerGroup = groups.find(group => group.value === value);
    this.setState(prevState => ({
      ...prevState,
      selectedGroupId: value,
      groupNameError: null,
      dealerGroup,
    }));
  };

  onSubmitForm = () => {
    const { selectedGroupId } = this.state;
    const { submitForm } = this.props;
    const validation = new Validator(this.state, {
      dealerGroup: 'required',
    });
    if (validation.fails()) {
      this.setState({
        groupNameError: validation.errors.errors.dealerGroup,
      });
    } else {
      this.setState({
        groupNameError: null,
        selectedGroupId: null,
        dealerGroup: null,
      });
      submitForm(
        selectedGroupId,
        DealerInfoAction.HANDLE_ASSIGN
      );
    }
  };

  onGetInitRevertData = () => {
    const { initialGroups } = this.state;
    if (initialGroups) {
      this.setState(prevState => ({ groups: prevState.initialGroups }));
    }
  };

  onCloseHandle = () => {
    const { onCloseForm } = this.props;
    this.setState({
      groupNameError: null,
      selectedGroupId: null,
      dealerGroup: null,
    });
    onCloseForm();
  };

  render() {
    const { openForm } = this.props;
    const {
      isLoading, groups, selectedGroupId, groupNameError,
    } = this.state;

    return (
      <Modal open={openForm}>
        <Modal.Header>Assign Group</Modal.Header>
        <Modal.Content image>
          <Modal.Description>
            <Form>
              <Header size='small' color='blue' />
              <Form.Group widths='equal'>
                <Form.Field required error={!isEmpty(groupNameError)}>
                  <label htmlFor='dealerGroup'>Dealer Group</label>
                  <Dropdown
                    id='dealerGroup'
                    placeholder='Input your Group Name'
                    options={groups}
                    fluid
                    selection
                    search
                    loading={isLoading}
                    value={selectedGroupId}
                    onChange={this.onHandleSelect('groupName')}
                    onSearchChange={this.handleSearchChange}
                    onClose={this.onGetInitRevertData}
                    selectOnBlur={false}
                    noResultsMessage='No result found'
                    className='short-scrolling-dropdown pre-wrap-dropdown'
                  />
                  {groupNameError && (
                    <div style={{ color: 'red' }}>{groupNameError}</div>
                  )}
                </Form.Field>
              </Form.Group>
            </Form>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          {/* {isLoading && (
            <Button loading positive>
              Submitting...
            </Button>
          )} */}

          <Button color='green' onClick={this.onSubmitForm} inverted>
            <Icon name='checkmark' /> Submit
          </Button>

          <Button onClick={this.onCloseHandle}>Cancel</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

AssignForm.propTypes = {
  submitForm: PropTypes.func.isRequired,
  onCloseForm: PropTypes.func.isRequired,
  openForm: PropTypes.bool.isRequired,
};

export default AssignForm;
